import * as a from '../libs/actions';
import * as c from '../libs/constants';
import * as aggr from "../libs/aggregation";
import * as u from "../libs/utils";

// reconnect swindon on interaction
export function socketStoreMutation() {
    return (next) => (state) => {
        const newMsgInChatsPredicate = aggr.isThereNewMessages(
        u.getSocketStore(state).get('chats'));

        u.changeFaviconOnMsg(newMsgInChatsPredicate);

        state = state.setIn(['errors', c.ERROR_NETWORK_UNAVAILABLE], navigator.onLine === false);
        return next(state);
    };
}

export function invokeActionListeners(actionsListeners) {
    return () => (next) => (state) => {

        const actionResult = next(state);

        switch(actionResult.params.action) {
            case a.EVENT_OPEN_DIALOG:
                actionsListeners[
                    c.OPEN_DIALOG_ACTION_LISTENERS].forEach((callback) => callback());
                break;
            case a.EVENT_BESIDA_INITIALIZED:
                actionsListeners[
                    c.INIT_ACTION_LISTENERS].forEach((callback) => callback());
                break;
            case a.EVENT_BESIDA_ERROR:
            case a.EVENT_BESIDA_MESSAGE:
            case a.EVENT_BESIDA_RERENDER:
            case a.EVENT_BESIDA_REGISTRY:
            case a.EVENT_BESIDA_COUNTERS:
            case a.EVENT_BESIDA_SEND_BAN_LIST:
            case a.EVENT_BESIDA_CHAT_META_SUCCESS:
            case a.EVENT_BESIDA_CHAT_HISTORY_SUCCESS:
                actionsListeners[
                    c.UPDATE_ACTION_LISTENERS].forEach((callback) => callback());
                break;
            default:
                break;
        }

        return actionResult;
    };
}
